import { render } from "./TableSimple.vue?vue&type=template&id=bb7acf52"
import script from "./TableSimple.vue?vue&type=script&lang=js"
export * from "./TableSimple.vue?vue&type=script&lang=js"

import "./TableSimple.vue?vue&type=style&index=0&id=bb7acf52&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__